// extracted by mini-css-extract-plugin
export default {"text":"statistics-card-v2_text__DbfhG","cardnumber":"statistics-card-v2_cardnumber__7a4M+"};